import React from 'react';
import ImageGallery from "react-image-gallery";
import Axios from 'axios';
import { createRoot } from 'react-dom/client';
import ShopProfile from './shopProfile';
//import "~react-image-gallery/styles/scss/image-gallery.scss";
//import "~react-image-gallery/styles/css/image-gallery.css";

/*const images = [
  {
    original: "https://picsum.photos/id/1018/1000/600/",
    thumbnail: "https://picsum.photos/id/1018/250/150/",
  },
  {
    original: "https://picsum.photos/id/1015/1000/600/",
    thumbnail: "https://picsum.photos/id/1015/250/150/",
  },
  {
    original: "https://picsum.photos/id/1019/1000/600/",
    thumbnail: "https://picsum.photos/id/1019/250/150/",
  },
];*/

export default class ShopGallery extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      pictures: [null],
      imgRoot: null,
      itemprop: null
    };
  }

  componentDidMount() {
    var url_string = window.location.href;
    //var url_string = 'https://www.erotikastore.eu/noi-ruha-fehernemu-axami-noi-also-brazil-stilusu-fekete-tanga/43-13275';
    var url = ShopProfile.getURL() + '/index/reactFetch.php';
    var data = new URLSearchParams({
      event: 'image-gallery',
      url: url_string,
      reverse: false
    });
    Axios.post(url, data)
      .then(res => {
        this.setState({
          pictures: res.data,
          itemprop: res.data[0]['original']
        })
      })
  }

  getImage() {
    const { pictures } = this.state;
    var { imgRoot } = this.state;
    var { itemprop } = this.state;
    if (imgRoot === null) {
      imgRoot = createRoot(document.getElementById('picture'));
      this.setState({ imgRoot: imgRoot })
    }
    if (pictures.length > 1) {
      setTimeout(function () {
        imgRoot.render(<div><link itemprop='image' href={itemprop}></link><ImageGallery items={pictures} /></div>);
      }, 50);
    }
  }

  render() {
    //const { pictures } = this.state;
    this.getImage();
    //return <ImageGallery items={pictures} />;
    return (
      <div>
      </div>
    );
  }
}